<p>{{ stringifiedPartners }}</p>
